import firebase from 'firebase/app';
import 'firebase/firestore';
// import { client } from '../index';
import { buildConfig } from '../config';

const config = buildConfig(process.env);

if (!firebase.apps.length) {
  firebase.initializeApp(config.firebase);
}

export const firestoreDatabase = firebase.firestore();

if (config.firebase.firestore.local) {
  firestoreDatabase.useEmulator(config.firebase.firestore.host, config.firebase.firestore.port);
}

export default class FirestoreService {
  database: firebase.firestore.Firestore;
  constructor() {
    this.database = firestoreDatabase;
  }
}
